import clsx from 'clsx';

/**
 * Container — centered max-width wrapper.
 *
 * Props:
 *   maxWidth - "sm" | "md" | "lg" | "xl" (default) | "2xl" | "full"
 *   px       - "sm" | "md" | "lg" (default) — horizontal padding
 */
const WIDTHS = {
  sm:    'max-w-screen-sm',
  md:    'max-w-screen-md',
  lg:    'max-w-screen-lg',
  xl:    'max-w-[1200px]',
  '2xl': 'max-w-[1320px]',
  full:  'max-w-full',
};

const PADS = {
  sm: 'px-3',
  md: 'px-4',
  lg: 'px-6',
};

export function Container({
  children,
  maxWidth  = 'xl',
  px        = 'lg',
  className = '',
  as: Tag   = 'div',
}) {
  return (
    <Tag className={clsx('w-full mx-auto', WIDTHS[maxWidth], PADS[px], className)}>
      {children}
    </Tag>
  );
}
